// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1mtcF","errorLogs":"styles_errorLogs__3pam5"};